/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, type FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  // DropdownList,
  LGBDatepicker,
  ListItem,
  Search,
  LGBPagination,
} from "@components";
import { ILocation, IRouteItem } from "../../types";
import { Label } from "flowbite-react";

export interface RouteItemProp {
  locationsList: ILocation[];
  selectedRouteId: string;
  select: (route: ILocation) => void;
  selectDate: (date: Date) => void;
  selectTime: (time: string) => void;
  route?: IRouteItem;
  label: string;
  showError?: boolean;
}

/**
 * TODO: Add validation colors to all fields in this component + the datepicker component. This should finish up this step.
 *
 */
export const RouteItem: FC<RouteItemProp> = (props) => {
  const { t } = useTranslation(["orders", "validation"]);
  const [searchResults, setSearchResults] = useState([] as ILocation[]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const errorStyle =
    "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500 dark:border-red-400 dark:bg-red-100 dark:focus:border-red-500 dark:focus:ring-red-500";
  useEffect(() => {
    setSelectedAddress(
      props.locationsList.find((x) => x.id === props.selectedRouteId)
        ?.displayName || "",
    );
  }, [props.selectedRouteId, props.locationsList]);

  const ExtendedSearch = (
    <div className="flex mb-2 items-center pt-2 md:pt-0 lg:pt-0 md:pl-4 lg:pl-4">
      {/* <div className="pr-4 w-full relative">
        <DropdownList />
      </div> */}
      <div className={"pr-4 w-full relative"}>
        <Label htmlFor="date" value={t("create.route_selection.date")} />
        <LGBDatepicker
          showError={props.showError}
          select={props.selectDate}
          selectedDate={props.route?.stopDate.toDate() as Date}
        />
      </div>
      <div className="w-full ">
        <Label
          htmlFor="time"
          value={t("create.route_selection.pick_up_after")}
        />
        <form className="">
          <div className="relative">
            <input
              type="time"
              id="time"
              className={
                (props.showError && !props.route?.timing ? errorStyle : "") +
                " border p-2.5 text-sm rounded-lg relative"
              }
              onChange={(e) => props.selectTime(e.target.value)}
              required
            />
            {props.showError && !props.route?.timing && (
              <span className="absolute left-0 -bottom-6 text-sm text-red-600 dark:text-red-500">
                {t("validation:route_info.time")}
              </span>
            )}
          </div>
        </form>
      </div>
    </div>
  );

  /**
   * Handle search logic
   * @param val search string
   */
  const handleSearch = (val: string) => {
    if (val !== "") {
      setSearchResults(
        props.locationsList.filter((x) =>
          x.displayName
            ? x.displayName.toLowerCase().includes(val.toLowerCase())
            : false,
        ) || ([] as ILocation[]),
      );
    } else {
      setSearchResults([]);
    }
  };

  const selectLocation = (val: ILocation) => {
    setSelectedAddress(val.displayName || "");
    setSearchResults([]);
    props.select(val);
  };

  return (
    <div>
      <Search
        expandSearchbar={ExtendedSearch}
        label={props.label}
        placeholder={t("create.route_selection.search_placeholder")}
        selected={selectedAddress}
        showError={props.showError}
        errorText={t("validation:route_info.location")}
        inputChanged={(val) => handleSearch(val)}
      >
        {searchResults.map((location: ILocation) => {
          return (
            <ListItem
              key={location.id}
              isSelected={location.id === props.selectedRouteId}
              buttonClickEvent={() => selectLocation(location)}
              id={location.id}
              title={location.displayName}
              subtitle={location.addressLine || ""}
              img={location.imgUrl || ""}
            ></ListItem>
          );
        })}
      </Search>
      <div className="flex justify-end">
        <LGBPagination
          maxPerPage={10}
          list={searchResults}
          updateList={(list: ILocation[]) => setSearchResults(list)}
        />
      </div>
    </div>
  );
};
